import cloneDeep from 'lodash/cloneDeep'
import { AccountTypes } from '@/constants/user/accountTypes'
import { USER_TYPE_CUSTOMER_COMPANY, USER_TYPE_CUSTOMER_PERSON } from '@/constants/user/roles'
import Skill from '@/models-ts/Skill'
import Channel from '@/models-ts/user/Channel'
import PrefferedCurrency from '@/models-ts/user/PrefferedCurrency'
import CompanyInfo from '../profiles/cutomer/CompanyInfo'
import GeneralInfo from '../profiles/cutomer/GeneralInfo'
import IndividualInfo from '../profiles/cutomer/IndividualInfo'

export default class CustomerDetails {
  userId: number
  isPretty: boolean
  fullName?: string
  bannedAt?: string
  avgReputation: number
  avgReviews: string
  completedJobs: number
  completedGigs: number
  roleWasSet: Boolean
  generalInfo: GeneralInfo
  individualInfo: IndividualInfo
  companyInfo: CompanyInfo
  skills: Array<Skill>
  currencies: Array<PrefferedCurrency>
  channels: Array<Channel>
  type: typeof USER_TYPE_CUSTOMER_PERSON | typeof USER_TYPE_CUSTOMER_COMPANY
  internalCountryId: number | null
  reviewsCount: number
  accountType: AccountTypes

  is_customer_verified: boolean
  constructor({
    userId,
    isPretty = true,
    is_customer_verified = false,
    fullName = '',
    bannedAt = '',
    avgReputation = 0,
    avgReviews = '0',
    completedJobs = 0,
    completedGigs = 0,
    roleWasSet = false,
    generalInfo,
    individualInfo,
    companyInfo,
    skills = [],
    currencies = [],
    channels = [],
    type = USER_TYPE_CUSTOMER_PERSON,
    internalCountryId = null,
    reviewsCount = 0,
    accountType = AccountTypes.USER_ACCOUNT_SIMPLE,
  }: Partial<CustomerDetails>) {
    Object.assign(
      this,
      cloneDeep({
        userId,
        isPretty,
        fullName,
        bannedAt,
        avgReputation,
        avgReviews,
        completedJobs,
        completedGigs,
        roleWasSet,
        generalInfo,
        individualInfo,
        companyInfo,
        skills,
        currencies,
        channels,
        type,
        internalCountryId,
        reviewsCount,
        accountType,
        is_customer_verified,
      })
    )
  }

  static fromServer(props: LX.CustomerDetails) {
    return new CustomerDetails({
      userId: props.user_id,
      isPretty: props.is_pretty,
      fullName: props.relations?.user?.name || '',
      bannedAt: props.relations?.user?.banned_at || '',
      avgReputation: props.avg_reputation,
      avgReviews: Number(props.avg_reviews || 0).toFixed(2),
      completedJobs: props.meta?.completed?.jobs || 0,
      completedGigs: props.meta?.completed?.gigs || 0,
      type: props.type,
      roleWasSet: props.first_save === 1,
      accountType: props.relations.user.type,
      is_customer_verified: Number(props.relations.user.is_customer_verified) === 1,
      generalInfo: GeneralInfo.fromServer(props),
      reviewsCount: props.reviews_count || 0,
      individualInfo: IndividualInfo.fromServer(props),
      companyInfo: CompanyInfo.fromServer(props),
      skills: (props.relations.Skill || []).map(Skill.fromServer),
      channels: (props.relations.Channel || []).map(Channel.fromServer),
      internalCountryId: props.internal_country_id,
      currencies: (props.relations.Currency || []).map(PrefferedCurrency.getFromSrever).filter(Boolean) as Array<PrefferedCurrency>,
    })
  }
}
